import React from 'react';
import { Sun, Moon } from 'lucide-react';
import { useTheme } from '../contexts/ThemeContext';

/**
 * Compact sun/moon theme toggle. Two visual variants:
 *   - "sidebar": full-width row for sidebar footers (dark styling)
 *   - "icon": bare icon-only button (works in either theme)
 */
export const ThemeToggle = ({ variant = 'icon' }) => {
  const { theme, toggleTheme } = useTheme();
  const isLight = theme === 'light';
  const Icon = isLight ? Sun : Moon;
  const nextLabel = isLight ? 'Switch to dark' : 'Switch to light';

  if (variant === 'sidebar') {
    return (
      <button
        type="button"
        onClick={toggleTheme}
        data-testid="theme-toggle-sidebar"
        className="flex items-center w-full px-3 py-2 text-sm text-white/40 hover:text-white/80 hover:bg-white/5 rounded-lg transition-colors"
        title={nextLabel}
      >
        <Icon className="w-4 h-4 mr-3" />
        <span>{isLight ? 'Light mode' : 'Dark mode'}</span>
        <span className="ml-auto text-[10px] uppercase tracking-wide text-white/25">
          {isLight ? 'switch to dark' : 'switch to light'}
        </span>
      </button>
    );
  }

  return (
    <button
      type="button"
      onClick={toggleTheme}
      data-testid="theme-toggle"
      title={nextLabel}
      aria-label={nextLabel}
      className="p-2 rounded-lg text-white/40 hover:text-white hover:bg-white/5 transition-colors"
    >
      <Icon className="w-4 h-4" />
    </button>
  );
};
